import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import LoginPage from './LoginPage';
import OnboardingSlides from './OnboardingSlides';
import { Loader2 } from 'lucide-react';

const AuthWrapper = ({ children }) => {
  const { currentUser, loading } = useAuth();
  const [onboardingDone, setOnboardingDone] = useState(
    () => localStorage.getItem('onboarding_seen') === 'true'
  );

  const completeOnboarding = () => {
    localStorage.setItem('onboarding_seen', 'true');
    setOnboardingDone(true);
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-purple-100 via-pink-50 to-indigo-100 flex items-center justify-center">
        <div className="text-center">
          <Loader2 className="w-12 h-12 text-purple-600 animate-spin mx-auto mb-4" />
          <p className="text-gray-600">{(navigator.language || 'en').toLowerCase().startsWith('fr') ? 'Chargement...' : 'Loading...'}</p>
        </div>
      </div>
    );
  }

  if (!currentUser) {
    if (!onboardingDone) {
      return <OnboardingSlides onComplete={completeOnboarding} />;
    }
    return <LoginPage />;
  }

  return children;
};

export default AuthWrapper;
